export type RightCapitalInboundContactSyncSettings = {
  autoSync: boolean
}

export type RightCapitalInboundSyncSettings = {
  contact: RightCapitalInboundContactSyncSettings
}

export type RightCapitalSettingsFormValues = {
  inbound: RightCapitalInboundSyncSettings
}

export const rightCapitalSettingsDefaultValues: RightCapitalSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
